export default "__VITE_ASSET__3bb54bd6__"